import { createFileRoute, Outlet } from "@tanstack/react-router";
export const Route=createFileRoute("/learn/personality")({component:()=> <Outlet/>});
